import React, { useState, useMemo, useEffect, ReactNode } from 'react';
import { Slider } from '@om-fe/widgets/dist/components/slider/slider';
import { navBem } from '@om-fe/widgets/dist/components/nav/nav.utils';
import { BemModifiersMap, AppState } from '@om-fe/core/core/types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { clearFalsy, PlatformTypes } from '@om-fe/utils';
import { 
  NextRaceEventListLoadLazy,
  FutureRaceLoadLazy,
  NextRaceEventListLoadSsr,
} from '@om-fe/core/core/widgets/omfe-widgets';
import { DisciplinesType } from '@om-fe/models';
import getConfig, { OMFE2ConfigModel } from '@om-fe/core/utils/config';
import { NextRaceNavItem } from './nav-item';

export enum NextRaceTab {
  All = 'All',
  UK = 'UK & Ireland',
  Future = 'Future',
  France = 'France',
  US = 'United States',
}

interface NextRaceEventListStore {
  readonly deviceType?: PlatformTypes;
  
}

interface NextRaceEventListPublicProps {
  readonly sportId?: string;
  readonly numberOfRaces?: number;
  readonly enabledLoadMore?: boolean;
}

type NextRaceEventListProps = NextRaceEventListPublicProps & NextRaceEventListStore;

const NextRaceEventList = ({
  deviceType,
  sportId,
  numberOfRaces,
  enabledLoadMore,
}: NextRaceEventListProps) => {
  const [activeTab, setActiveTab] = useState<string>('All');
  const config: OMFE2ConfigModel = getConfig();
  const locationNav: NextRaceTab[] | undefined = sportId === DisciplinesType.GreyHounds ? config.race?.greyHounds?.locationNav : config.race?.horseRacing?.locationNav;
  const hasLocationNav: boolean = !!locationNav?.length;
  const isAppLazy: boolean = getConfig()?.isAppLazy || false;
  
  useEffect(() => {
    setActiveTab('All');
  }, [sportId])

  const nextRaceComponent = useMemo(() => {
    const NextRaceEventList = isAppLazy ? NextRaceEventListLoadSsr : NextRaceEventListLoadLazy;

    switch (activeTab) {
      case NextRaceTab.All:
        return (
          <NextRaceEventList
            deviceType={deviceType}
            sportId={sportId}
            numberOfRaces={numberOfRaces}
            enabledLoadMore={enabledLoadMore}
          />
        );
      case NextRaceTab.UK:
        return (
          <NextRaceEventList
            location={`104,76,78,79,80`}
            deviceType={deviceType}
            sportId={sportId}
          />
        );
      case NextRaceTab.France:
        return (
          <NextRaceEventList
            location={`73`}
            deviceType={deviceType}
            sportId={sportId}
          />
        );
      case NextRaceTab.US:
        return (
          <NextRaceEventList
            location={`229`}
            deviceType={deviceType}
            sportId={sportId}
          />
        );
      case NextRaceTab.Future:
        return (
          <FutureRaceLoadLazy sportId={sportId} />
        );
      default:
        return null;
    }
  }, [activeTab, sportId]);
  
  const handleChangeNavTab = (navName: string) => {
    setActiveTab(navName);
  }

  const modifiers: BemModifiersMap = {
      Nav: true,
      ItemToStartUnequalWidth: true,
      Small10: true,
      Tertiary: true,
  };

  const navList: NextRaceTab[] = clearFalsy<NextRaceTab>(
    hasLocationNav && locationNav
      ? locationNav
      : [
          NextRaceTab.All,
          NextRaceTab.UK,
          sportId !== DisciplinesType.GreyHounds && NextRaceTab.France,
          sportId !== DisciplinesType.GreyHounds && NextRaceTab.US,
          NextRaceTab.Future,
        ]
  );

  const sliderItem: ReactNode[] = navList.map((navName: string, key: number) => {
    return (
      <NextRaceNavItem
        key={key}
        navName={navName}
        handleClickAnchor={handleChangeNavTab}
        activeTab={activeTab}
      />
    );
  });

  return (
    <>
      <div className={navBem()}>
        <Slider
            sliderItems={sliderItem}
            modifiersFromParent={modifiers}
            hasArrows={deviceType === 'desktop'}
        />
      </div>
      <br />
      {nextRaceComponent}
    </>
  );
}

const NextRaceEventListPage = compose(
  connect((state: AppState): NextRaceEventListStore  => {

    return {
      deviceType: state.deviceInfo?.platform.type,
    }
  }),
)(NextRaceEventList);
export default NextRaceEventListPage;